import { GlobalStyles, ThemeProvider } from "@mui/material";
import { AuthProvider } from "./contexts/auth";
import Routes from "./routes";
import { GLOBAL_STYLES, THEME } from "./styles/theme";
import { NotificationProvider } from "./contexts";

function App() {
  return (
    <ThemeProvider theme={THEME}>
      <GlobalStyles styles={GLOBAL_STYLES} />
      <NotificationProvider>
        <AuthProvider>
          <Routes />
        </AuthProvider>
      </NotificationProvider>
    </ThemeProvider>
  );
}

export default App;
